import { CardImage, H5, H6, ProfilePicture } from "@sellar-io/components";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type DiscoveryV2DistributionSupplierCardProps = {
  imageUrl: string;
  logoUrl: string;
  businessName: string;
  deliveryAddressCity: string;
  className?: string;
  onClick: ComponentProps<"button">["onClick"];
};

export const DiscoveryV2DistributionSupplierCard = ({
  logoUrl,
  imageUrl,
  businessName,
  deliveryAddressCity,
  className,
  onClick,
}: DiscoveryV2DistributionSupplierCardProps) => {
  return (
    <button
      type="button"
      className={twMerge(
        "flex w-50 min-w-50 cursor-pointer flex-col gap-2 rounded-2xl bg-white drop-shadow-md",
        className,
      )}
      onClick={onClick}
    >
      <CardImage
        imageUrl={imageUrl}
        fallback="supplier-hero"
        className="h-30 rounded-t-2xl"
      />
      <div className="flex gap-2 rounded-b-lg p-2">
        <ProfilePicture
          logoUrl={logoUrl}
          size="medium"
          name={businessName}
          fallback="supplier-badge"
          className="flex items-center"
        />
        <div className="flex min-w-0 flex-1 flex-col justify-center">
          <H5 className="truncate text-left text-sm font-semibold">
            {businessName}
          </H5>
          <H6 className="text-left text-xs font-normal">
            {deliveryAddressCity}
          </H6>
        </div>
      </div>
    </button>
  );
};
